"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./AdditionalApi"), exports);
__exportStar(require("./AdminApi"), exports);
__exportStar(require("./AuthorApi"), exports);
__exportStar(require("./ContentApi"), exports);
__exportStar(require("./DEVELOPMENTONLYApi"), exports);
__exportStar(require("./EventApi"), exports);
__exportStar(require("./FormApi"), exports);
__exportStar(require("./MeasurementApi"), exports);
__exportStar(require("./OembedApi"), exports);
__exportStar(require("./PageApi"), exports);
__exportStar(require("./SiteApi"), exports);
__exportStar(require("./TagApi"), exports);
__exportStar(require("./UEFAAPIApi"), exports);
